import * as React from 'react';
import { classNames } from 'uitk-react-utils';
import { ErrorBoundary } from 'bernie-view';

const mesoAdEventName = 'mesoAd';

interface MesoDisplayAdProps {
  uci: string;
  mediaquery?: string;
  className?: string;
}

interface MesoDisplayAdState {
  isCollapsed: boolean;
}

export class MesoDisplayAd extends React.Component<MesoDisplayAdProps, MesoDisplayAdState> {
  private displayAd;

  constructor(props) {
    super(props);

    this.state = {
      isCollapsed: false
    };

    this.displayAd = React.createRef();
    this.updateVisibility = this.updateVisibility.bind(this);
  }

  private updateVisibility(event) {
    this.setState({
      isCollapsed: event.detail && event.detail.code !== 'AD-LOAD-PASS'
    });
  }

  public componentDidMount() {
    this.displayAd.current.addEventListener(mesoAdEventName, this.updateVisibility);
  }

  public componentWillUnmount() {
    this.displayAd.current.removeEventListener(mesoAdEventName, this.updateVisibility);
  }

  public render() {
    const className = classNames('ad-div', 'display-ad', {
      'is-visually-hidden': this.state.isCollapsed,
      [this.props.className]: this.props.className && !this.state.isCollapsed
    });

    return (
      <ErrorBoundary label="meso.display.ad">
        <meso-display-ad ref={this.displayAd} mediaquery={this.props.mediaquery} uci={this.props.uci} class={className} />
      </ErrorBoundary>
    );
  }
}
